module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/2-4ec12310f5660ad42e599b875474ff4e.jpg";